// general getters
export const authToken = state => state.authToken
export const currency = state => state.currency
